import {inject, Injectable} from '@angular/core';
import {BaseComponent, IWMSStandaloneEditorConstructionOptions, WMSEditorComponent} from "@wms/components";
import {AppResourceManagerService} from "@wms/design-container";
import {SecurityService} from "@wms/settings/security";
import {DialogService, FileService, NotificationService} from "@wms/services";
import {EventManagerService} from "@wms/app/event-manager";
import {WmsWorkspaceManagerService} from "@wms/workspace";
import {deleteResourceRestricted} from "@wms/core";
type activeResource = {
  name: string;
  path: string;
  type: any;
  relativePath: string;
  absPath: string;
  allowEdit: boolean;
  allowDelete: boolean;
};
type project = {
  name: string;
  projectId: string;
  studioProjectId: string;
  branchType: string;
  vcsBranch: string;
  defaultLanguage: string;
};

@Injectable({
  providedIn: 'root'
})
export class FileWorkspaceService extends BaseComponent{
  RESOURCE_TYPES = {
    'TEXT': 'TEXT',
    'IMAGE': 'IMAGE',
    'CANNOT_DISPLAY': 'CANNOT_DISPLAY',
    'FOLDER': 'FOLDER'
  };
  project: project = {
    name: "",
    projectId: "",
    studioProjectId: "",
    branchType: "",
    vcsBranch: "",
    defaultLanguage: ""
  };
  activeResource: activeResource = {
    path: "",
    relativePath: "",
    name: "",
    type: undefined,
    allowEdit: false,
    allowDelete: false,
    absPath: ""
  };
  resourceModified: boolean;
  editorOptions: IWMSStandaloneEditorConstructionOptions = { value: '' };
  private resourceMngr: AppResourceManagerService;
  private securityService: SecurityService;
  fileService:FileService;
  notificationService:NotificationService

  wsManager:WmsWorkspaceManagerService;
  dialogService: DialogService;
  private editorComponent:WMSEditorComponent


  constructor() {
    super();
    this.resourceMngr = inject(AppResourceManagerService);
    this.securityService = inject(SecurityService);
    this.fileService = inject(FileService);
    this.notificationService = inject(NotificationService);
    this.wsManager = inject(WmsWorkspaceManagerService);
    this.dialogService = inject(DialogService);
  }

  setEditor(editor: WMSEditorComponent) {
    this.editorComponent = editor;
  }


  changeEditorFontSize($event: Event): void {
    this.editorOptions = {...this.editorOptions, fontSize: parseInt(($event.target as HTMLInputElement).value)};
  }

  changeEditorTheme($event: Event): void {
    this.editorOptions = {...this.editorOptions, theme: ($event.target as HTMLInputElement).value};
  }


  // async save(resourcePath: string): Promise<void> {
  //   await this.editorComponent.triggerFormat();
  //   this.securityService._authInfo =  undefined;
  //   return this.fileService.save(resourcePath, this.editorOptions.value).then((): void => {
  //     // Changes made in the files(html,css,js,variables.json) should be reflected when we route again to page workspace
  //     // so removing the cache.
  //     this.securityService.getAuthInfo();
  //     const pageNamePattern = '[a-zA-Z0-9_-]+';
  //     const fileExtensions = 'html|js|variables\\.json|css';
  //     const patternString = `\\/pages\\/(${pageNamePattern})\\/\\1\\.(${fileExtensions})`;
  //     const pattern = new RegExp(patternString);
  //     const match = resourcePath.match(pattern);
  //     if (match) {
  //       this.resourceMngr.removeUrlCache(match[1]);
  //     }
  //     this.notificationService.show("success", this.locale["MESSAGE_SUCCESS_TITLE"], this.locale["MESSAGE_SUCCESS_SAVE_FILE_DESC"]);
  //     this.resourceModified = false;
  //     this.wsManager.setDirtyonWs(this.resourceModified);
  //     const pathArr = resourcePath.split("/")
  //     if(pathArr.length && pathArr.at(-1) === 'app.variables.json'){
  //         this.eventManager.emitReloadAppVariables()
  //     }
  //     if (pathArr.length && pathArr.includes('overrides')) {
  //       this.eventManager.emitReloadDesignTokens();
  //     }
  //   });
  // }





  async save(resourcePath: string): Promise<void> {
    if(this.editorComponent) {
      await this.editorComponent.triggerFormat();
    }
    this.securityService._authInfo =  undefined;
    return this.fileService.save(resourcePath, this.editorOptions.value).then((): void => {
      // Changes made in the files(html,css,js,variables.json) should be reflected when we route again to page workspace
      // so removing the cache.
      this.securityService.getAuthInfo();
      const pageNamePattern = '[a-zA-Z0-9_-]+';
      const fileExtensions = 'html|js|variables\\.json|css';
      const patternString = `\\/pages\\/(${pageNamePattern})\\/\\1\\.(${fileExtensions})`;
      const pattern = new RegExp(patternString);
      const match = resourcePath.match(pattern);
      if (match) {
        this.resourceMngr.removeUrlCache(match[1]);
      }
      this.notificationService.show("success", this.locale["MESSAGE_SUCCESS_TITLE"], this.locale["MESSAGE_SUCCESS_SAVE_FILE_DESC"]);
      this.resourceModified = false;
      this.wsManager.setDirtyonWs(this.resourceModified);
      const pathArr = resourcePath.split("/")
      if(pathArr.length && pathArr.at(-1) === 'app.variables.json'){
        this.eventManager.emitReloadAppVariables()
      }
      if (pathArr.length && pathArr.includes('overrides')) {
        this.eventManager.emitReloadDesignTokens();
      }
    });
  }

  deleteIconClick(): void {
    if (deleteResourceRestricted('project', this.activeResource.path)) {
      this.notificationService.show("error", this.locale["MESSAGE_ERROR_TITLE"], this.locale["MESSAGE_ERROR_DELETE_SELECT_RESOURCE"]);
      return;
    }
    if (this.activeResource.path.includes("i18n/" + this.project.defaultLanguage + ".json") ||  this.activeResource.relativePath.includes('i18n/en.json')) {
      this.notificationService.show("error", this.locale["MESSAGE_ERROR_TITLE"], this.locale["MESSAGE_ERROR_DELETE_DEFAULT_LANGUAGE_NOT_ALLOWED"]);
      return;
    }
    this.dialogService.open('deleteResourceModal');
  }

}
